<div class="main-content">
  <div class="container-fluid">

    <!-- Service tabs -->
    <div class="service-tabs">
      <button *ngFor="let svc of SERVICE_TYPES"
              (click)="setService(svc)"
              [class.active]="activeService === svc"
              class="service-tab">
        {{ SERVICE_LABELS[svc] }}
      </button>
    </div>

    <!-- Controls row -->
    <div class="admin-controls">
      <div class="filter-pills">
        <button (click)="changeFilter(AssociationStatusFilter.all)"
                [class.active]="filter == AssociationStatusFilter.all"
                class="pill">All</button>
        <button (click)="changeFilter(AssociationStatusFilter.open)"
                [class.active]="filter == AssociationStatusFilter.open"
                class="pill">Open</button>
        <button (click)="changeFilter(AssociationStatusFilter.identified)"
                [class.active]="filter == AssociationStatusFilter.identified"
                class="pill pill--info">Identified</button>
        <button (click)="changeFilter(AssociationStatusFilter.selected)"
                [class.active]="filter == AssociationStatusFilter.selected"
                class="pill pill--info">Selected</button>
        <button (click)="changeFilter(AssociationStatusFilter.approved)"
                [class.active]="filter == AssociationStatusFilter.approved"
                class="pill pill--success">Approved</button>
        <button (click)="changeFilter(AssociationStatusFilter.not_approved)"
                [class.active]="filter == AssociationStatusFilter.not_approved"
                class="pill pill--danger">Not Approved</button>
        <button (click)="changeFilter(AssociationStatusFilter.completed)"
                [class.active]="filter == AssociationStatusFilter.completed"
                class="pill pill--warning">Completed</button>
        <button (click)="changeFilter(AssociationStatusFilter.closed)"
                [class.active]="filter == AssociationStatusFilter.closed"
                class="pill">Closed</button>
      </div>
      <div class="controls-right">
        <div class="search-wrap">
          <i class="fa fa-search search-icon"></i>
          <input class="form-control search-input"
                 placeholder="Search by name, acronym…"
                 [(ngModel)]="search">
        </div>
      </div>
    </div>

    <!-- Sort row -->
    <div class="sort-row">
      <span class="sort-label">Sort:</span>
      <button (click)="changeSort('name')" class="btn btn-xs btn-sort" [class.active]="sortBy === 'name'">
        Name
        <i class="fa" [ngClass]="sortBy === 'name' ? (sortDirection === 1 ? 'fa-sort-asc' : 'fa-sort-desc') : 'fa-sort'"></i>
      </button>
      <button (click)="changeSort('surname')" class="btn btn-xs btn-sort" [class.active]="sortBy === 'surname'">
        Surname
        <i class="fa" [ngClass]="sortBy === 'surname' ? (sortDirection === 1 ? 'fa-sort-asc' : 'fa-sort-desc') : 'fa-sort'"></i>
      </button>
      <button (click)="changeSort('projectName')" class="btn btn-xs btn-sort" [class.active]="sortBy === 'projectName'">
        Project Name
        <i class="fa" [ngClass]="sortBy === 'projectName' ? (sortDirection === 1 ? 'fa-sort-asc' : 'fa-sort-desc') : 'fa-sort'"></i>
      </button>
      <button (click)="changeSort('acronym')" class="btn btn-xs btn-sort" [class.active]="sortBy === 'acronym'">
        Acronym
        <i class="fa" [ngClass]="sortBy === 'acronym' ? (sortDirection === 1 ? 'fa-sort-asc' : 'fa-sort-desc') : 'fa-sort'"></i>
      </button>
    </div>

    <loader *ngIf="loading"></loader>

    <div *ngIf="!loading && sortedProjects().length === 0" class="empty-state">
      <i class="fa fa-inbox fa-2x"></i>
      <p>No projects match the current filter.</p>
    </div>

    <!-- Project list -->
    <div *ngIf="!loading" class="epe-list">
      <div *ngFor="let project of sortedProjects()" class="epe-item">

        <!-- Summary row -->
        <div class="epe-summary" (click)="expand(project.application_id)">

          <div class="epe-id-col">
            <span class="user-name" *ngIf="project.name || project.surname">
              {{ project.name }} {{ project.surname }}
            </span>
            <span class="user-id" *ngIf="project.project_acronym">{{ project.project_acronym }}</span>
            <span class="user-id">User&nbsp;#{{ project.id }}</span>
            <span class="label epe-status-badge" [ngClass]="getStatusBadgeClass(getStatus(project.application_id))">
              {{ getStatusLabel(getStatus(project.application_id)) }}
            </span>
          </div>

          <div class="epe-info-col">
            <div class="assoc-project-name" *ngIf="project.full_project_name">
              {{ project.full_project_name }}
            </div>
            <div class="epe-submitted">
              <span class="epe-submitted-label">Submitted</span>
              {{ project.created_at | date:'d MMM yyyy' }}
            </div>
          </div>

          <div class="epe-right-col">
            <button class="btn btn-sm btn-action">
              <i class="fa" [ngClass]="selected === project.application_id ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
              {{ selected === project.application_id ? 'Close' : getBtnText(project.application_id) }}
            </button>
          </div>

        </div>

        <!-- Expanded detail -->
        <div *ngIf="selected === project.application_id" class="epe-detail">
          <div class="row">

            <!-- Left: project info -->
            <div class="col-md-8">

              <!-- User Profile -->
              <div class="detail-section" *ngIf="project.user_info">
                <h5 class="detail-section-title">User Profile</h5>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="detail-field"><label>Name</label><p>{{ project.user_info.name || '—' }} {{ project.user_info.surname || '' }}</p></div>
                  </div>
                  <div class="col-sm-6">
                    <div class="detail-field"><label>Username</label><p>{{ project.user_info.username || '—' }}</p></div>
                  </div>
                  <div class="col-sm-6">
                    <div class="detail-field"><label>Email</label><p>{{ project.user_info.email || '—' }}</p></div>
                  </div>
                  <div class="col-sm-6">
                    <div class="detail-field"><label>Organisation</label><p>{{ project.user_info.organisation || '—' }}</p></div>
                  </div>
                  <div class="col-sm-6">
                    <div class="detail-field"><label>Country</label><p>{{ project.user_info.country || '—' }}</p></div>
                  </div>
                  <div class="col-sm-6" *ngIf="project.user_info.organisation_type">
                    <div class="detail-field"><label>Organisation Type</label><p>{{ project.user_info.organisation_type }}</p></div>
                  </div>
                </div>
              </div>

              <!-- About Your Project -->
              <div class="detail-section">
                <h5 class="detail-section-title">About Your Project</h5>
                <div class="row">
                  <div class="col-sm-4">
                    <div class="detail-field"><label>Acronym</label><p>{{ project.form_data?.project_acronym || project.project_acronym || '—' }}</p></div>
                  </div>
                  <div class="col-sm-8">
                    <div class="detail-field"><label>Full Name</label><p>{{ project.form_data?.full_project_name || project.full_project_name || '—' }}</p></div>
                  </div>
                  <div class="col-sm-6" *ngIf="project.form_data?.funding_type">
                    <div class="detail-field"><label>Funding Type</label><p>{{ project.form_data?.funding_type }}</p></div>
                  </div>
                  <div class="col-sm-6">
                    <div class="detail-field"><label>Funding Programme</label><p>{{ project.form_data?.funding_programme || '—' }}<span *ngIf="project.form_data?.other_funding_programme" class="text-muted"> — {{ project.form_data?.other_funding_programme }}</span></p></div>
                  </div>
                  <ng-container *ngIf="project.form_data?.national_programme_name || project.form_data?.national_programme_country">
                    <div class="col-sm-6">
                      <div class="detail-field"><label>National Programme</label><p>{{ project.form_data?.national_programme_name || '—' }}</p></div>
                    </div>
                    <div class="col-sm-6">
                      <div class="detail-field"><label>National Programme Country</label><p>{{ project.form_data?.national_programme_country || '—' }}</p></div>
                    </div>
                  </ng-container>
                  <div class="col-sm-6">
                    <div class="detail-field"><label>Grant Agreement Number</label><p>{{ project.form_data?.grant_agreement || '—' }}</p></div>
                  </div>
                  <div class="col-sm-6" *ngIf="project.form_data?.coordinator_country">
                    <div class="detail-field"><label>Coordinator Country</label><p>{{ project.form_data?.coordinator_country }}</p></div>
                  </div>
                  <div class="col-sm-6">
                    <div class="detail-field"><label>Project Call / Topic ID</label><p>{{ project.form_data?.project_call_topic_id || '—' }}</p></div>
                  </div>
                  <div class="col-sm-6">
                    <div class="detail-field">
                      <label>Project Website</label>
                      <p>
                        <a *ngIf="project.form_data?.project_website; else assocNoWebsite"
                           [href]="project.form_data?.project_website" target="_blank" rel="noopener">
                          {{ project.form_data?.project_website }}
                        </a>
                        <ng-template #assocNoWebsite>—</ng-template>
                      </p>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="detail-field"><label>Project Officer Name</label><p>{{ project.form_data?.project_officer_name || '—' }}</p></div>
                  </div>
                  <div class="col-sm-6" *ngIf="project.form_data?.project_officer_email">
                    <div class="detail-field"><label>Project Officer Email</label><p>{{ project.form_data?.project_officer_email }}</p></div>
                  </div>
                </div>
              </div>

              <!-- Open Call Topics -->
              <div class="detail-section">
                <h5 class="detail-section-title">Open Call Topics</h5>
                <div *ngIf="getTopicLabels(project).length > 0">
                  <span *ngFor="let t of getTopicLabels(project)" class="topic-badge-detail">{{ t }}</span>
                </div>
                <span *ngIf="getTopicLabels(project).length === 0" class="text-muted">—</span>
              </div>

              <!-- About the Support -->
              <div class="detail-section">
                <h5 class="detail-section-title">About the Support</h5>
                <div class="detail-field" *ngIf="project.form_data?.information_to_attain?.length > 0">
                  <label>Information / Support requested</label>
                  <ul class="list-unstyled" style="margin: 4px 0 0;">
                    <li *ngFor="let item of project.form_data?.information_to_attain" style="margin-bottom: 3px;">
                      <i class="fa fa-check" style="color:#27ae60; margin-right:5px;"></i>{{ item }}
                    </li>
                  </ul>
                </div>
                <div class="detail-field" *ngIf="project.form_data?.project_short_description">
                  <label>Short Project Description</label>
                  <p class="tell-us-more">{{ project.form_data.project_short_description }}</p>
                </div>
                <div class="detail-field" *ngIf="project.form_data?.why_the_project_applying">
                  <label>Why applying?</label>
                  <p class="tell-us-more">{{ project.form_data?.why_the_project_applying }}</p>
                </div>
                <div class="detail-field" *ngIf="project.form_data?.other_support_specification">
                  <label>Other support specification</label>
                  <p class="tell-us-more">{{ project.form_data?.other_support_specification }}</p>
                </div>

                <ng-container *ngIf="project.application_type === 'service2'">
                  <div class="detail-field" *ngIf="project.form_data?.support_expectations">
                    <label>What do you expect from HSbooster.eu II proposal support?</label>
                    <p class="tell-us-more">{{ project.form_data?.support_expectations }}</p>
                  </div>
                  <div class="detail-field" *ngIf="project.form_data?.one_pager_file_id">
                    <label>1-pager</label>
                    <p>
                      <a [href]="'/api/v1/applications/cv-download/' + project.form_data.one_pager_file_id"
                         target="_blank" rel="noopener" class="cv-link">
                        <i class="fa fa-file-pdf-o"></i> Download 1-pager
                      </a>
                    </p>
                  </div>
                  <div class="detail-field" *ngIf="project.form_data?.objectives_standardisation">
                    <label>Standardisation activities mentioned in the call text</label>
                    <p class="tell-us-more">{{ project.form_data?.objectives_standardisation }}</p>
                  </div>
                  <div class="row">
                    <div class="col-sm-6" *ngIf="project.form_data?.trl_start">
                      <div class="detail-field"><label>TRL starting point</label><p>{{ project.form_data?.trl_start }}</p></div>
                    </div>
                    <div class="col-sm-6" *ngIf="project.form_data?.trl_target">
                      <div class="detail-field"><label>Expected TRL after the project</label><p>{{ project.form_data?.trl_target }}</p></div>
                    </div>
                  </div>
                  <div class="detail-field" *ngIf="project.form_data?.applicable_regulations">
                    <label>Applicable regulations</label>
                    <p class="tell-us-more">{{ project.form_data?.applicable_regulations }}</p>
                  </div>
                  <div class="detail-field" *ngIf="project.form_data?.call_deadline">
                    <label>Call deadline</label>
                    <p>{{ project.form_data?.call_deadline | date:'d MMMM yyyy' }}</p>
                  </div>
                </ng-container>
              </div>

              <!-- Availability and Language (PSS) -->
              <div class="detail-section" *ngIf="project.application_type === 'service2' && (project.form_data?.support_start || project.form_data?.scheduling_constraints || project.form_data?.preferred_languages || project.form_data?.time_zone)">
                <h5 class="detail-section-title">Availability and Language Preference</h5>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="detail-field"><label>Support start</label><p>{{ project.form_data?.support_start || '—' }}</p></div>
                  </div>
                  <div class="col-sm-6">
                    <div class="detail-field"><label>Scheduling constraints</label><p class="tell-us-more">{{ project.form_data?.scheduling_constraints || '—' }}</p></div>
                  </div>
                  <div class="col-sm-6">
                    <div class="detail-field"><label>Preferred language(s)</label><p>{{ project.form_data?.preferred_languages || '—' }}</p></div>
                  </div>
                  <div class="col-sm-6">
                    <div class="detail-field"><label>Time zone</label><p>{{ project.form_data?.time_zone || '—' }}</p></div>
                  </div>
                </div>
              </div>

              <!-- Standards Knowledge -->
              <div class="detail-section" *ngIf="project.form_data?.know_standards">
                <h5 class="detail-section-title">Standards Knowledge</h5>
                <div class="detail-field">
                  <label>Already knows relevant standards?</label>
                  <p>{{ project.form_data?.know_standards === 'yes' ? 'Yes' : 'No' }}</p>
                  <p *ngIf="project.application_type === 'service2' && project.form_data?.know_standards === 'yes' && project.form_data?.standards_details" class="tell-us-more">{{ project.form_data?.standards_details }}</p>
                </div>
                <ng-container *ngIf="project.application_type === 'service2'">
                  <div class="detail-field" *ngIf="project.form_data?.nsb_contact">
                    <label>Contact with a National Standardisation Body</label>
                    <p>{{ project.form_data?.nsb_contact === 'yes' ? ('Yes — ' + (project.form_data?.nsb_contact_name || '—')) : 'No' }}</p>
                  </div>
                  <div class="detail-field" *ngIf="project.form_data?.known_standards_yn">
                    <label>Knows standards relevant to the future project</label>
                    <p>{{ project.form_data?.known_standards_yn === 'yes' ? ('Yes — ' + (project.form_data?.known_standards_titles || '—')) : 'No' }}</p>
                  </div>
                </ng-container>
                <ng-container *ngIf="project.form_data?.know_standards === 'yes'">
                  <div *ngFor="let ref of project.form_data?.standard_reference; let i = index" class="group-card">
                    <div class="group-card-header">Standard #{{ i + 1 }}</div>
                    <div class="group-card-body">
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="detail-field"><label>SDO / NSB</label><p>{{ $any(ref).sdo || '—' }}<span *ngIf="$any(ref).other_options" class="text-muted"> — {{ $any(ref).other_options }}</span></p></div>
                        </div>
                        <div class="col-sm-3" *ngIf="$any(ref).tc_number">
                          <div class="detail-field"><label>TC/SC/WG No.</label><p>{{ $any(ref).tc_number }}</p></div>
                        </div>
                        <div class="col-sm-3" *ngIf="$any(ref).tc_title">
                          <div class="detail-field"><label>TC/SC/WG Title</label><p>{{ $any(ref).tc_title }}</p></div>
                        </div>
                        <div class="col-sm-12">
                          <div class="detail-field">
                            <label>Relationship</label>
                            <p>
                              <span *ngIf="$any(ref).is_contribute">Contribute</span>
                              <span *ngIf="$any(ref).is_contribute && $any(ref).is_use"> · </span>
                              <span *ngIf="$any(ref).is_use">Use / implement</span>
                              <span *ngIf="!$any(ref).is_contribute && !$any(ref).is_use" class="text-muted">—</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>

              <!-- Consent -->
              <div class="detail-section">
                <h5 class="detail-section-title">Consent</h5>
                <div class="row">
                  <div class="col-sm-4" *ngIf="project.application_type !== 'service2'">
                    <div class="detail-field"><label>Publish project information on website</label><p>{{ project.form_data?.website_publication ? 'Yes' : 'No' }}</p></div>
                  </div>
                  <div class="col-sm-4">
                    <div class="detail-field"><label>Data processing consent</label><p>{{ project.form_data?.data_consent ? 'Agreed' : '—' }}</p></div>
                  </div>
                  <div class="col-sm-4">
                    <div class="detail-field"><label>Accuracy declaration</label><p>{{ project.form_data?.accuracy_declaration ? 'Agreed' : '—' }}</p></div>
                  </div>
                </div>
              </div>

            </div>

            <!-- Right: matching + association panel -->
            <div class="col-md-4">

              <!-- EPE Ranked Suggestions -->
              <div class="action-panel" style="margin-bottom: 12px;">
                <div class="action-panel-header">
                  <i class="fa fa-list-ol" style="margin-right:5px;"></i>
                  EPE Suggestions
                  <span *ngIf="getMatchCount(project) > 0" class="header-match-count">
                    {{ getMatchCount(project) }} topic match{{ getMatchCount(project) !== 1 ? 'es' : '' }}
                  </span>
                </div>

                <div *ngIf="getCachedMatchingEpes(project.application_id).length === 0" style="padding: 12px 14px;">
                  <p class="suggestion-empty">No voted EPEs available yet.</p>
                </div>

                <div *ngIf="getCachedMatchingEpes(project.application_id).length > 0" class="suggestion-list">

                  <ng-container *ngFor="let item of getCachedMatchingEpes(project.application_id); let i = index">

                    <!-- Separator between matched and unmatched EPEs -->
                    <div *ngIf="item.showSeparator" class="suggestion-separator">
                      <span>No topic match</span>
                    </div>

                    <!-- EPE row -->
                    <div class="suggestion-row"
                         [class.suggestion-row--selected]="selectedSuggestionId === item.epe.application_id"
                         [class.suggestion-row--associated]="isAssociated(project.application_id, item.epe.application_id)"
                         (click)="selectSuggestedEpe(item.epe.application_id)">

                      <span class="suggestion-rank">#{{ i + 1 }}</span>

                      <div class="suggestion-info">
                        <span class="suggestion-name">
                          {{ item.epe.name || item.epe.user_info?.name }} {{ item.epe.surname || item.epe.user_info?.surname }}
                        </span>
                        <span class="suggestion-org" *ngIf="item.epe.organisation || item.epe.user_info?.organisation">
                          {{ item.epe.organisation || item.epe.user_info?.organisation }}
                        </span>
                      </div>

                      <div class="suggestion-meta">
                        <span class="suggestion-score" *ngIf="item.epe.score">
                          {{ item.epe.score | number:'1.1-1' }}
                        </span>
                        <span class="epe-match-badge" [ngClass]="getMatchBadgeClass(item.match)">
                          {{ getMatchLevelLabel(item.match) }}
                        </span>
                        <i *ngIf="isAssociated(project.application_id, item.epe.application_id)"
                           class="fa fa-link suggestion-linked" title="Already associated"></i>
                      </div>

                      <i class="fa suggestion-check"
                         [ngClass]="selectedSuggestionId === item.epe.application_id ? 'fa-check-circle' : 'fa-circle-o'"></i>

                    </div>

                  </ng-container>
                </div>

                <!-- Selected EPE label -->
                <div *ngIf="selectedSuggestionId" class="suggestion-selection-bar">
                  <i class="fa fa-check-circle"></i>
                  Selected: <strong>{{ getSelectedEpeName(project.application_id) }}</strong>
                </div>

              </div>

              <!-- Association management -->
              <association-sopcard-small
                [association_status]="getStatus(project.application_id)"
                [epes]="getProjectEpes(project.application_id)"
                [project_id]="project.application_id"
                (associationChanged)="reloadAssociations()">
              </association-sopcard-small>

            </div>

          </div>
        </div>

      </div>
    </div>

  </div>
</div>
<simple-alert [message]="alertMessage" [alert]="alertType" [(show)]="showAlert"></simple-alert>
